import { render, staticRenderFns } from "./TableProfit.vue?vue&type=template&id=7b83c787&scoped=true"
import script from "./TableProfit.vue?vue&type=script&lang=js"
export * from "./TableProfit.vue?vue&type=script&lang=js"
import style0 from "./TableProfit.vue?vue&type=style&index=0&id=7b83c787&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83c787",
  null
  
)

export default component.exports